import styled from 'styled-components';
import { AlertTypes } from '.';

export const Container = styled.div<{ type?: AlertTypes }>`
  position: relative;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.main};
  padding-left: 3rem;
  font-family: ${({ theme }) => theme.fonts.archivo};

  ${({
    type,
    theme: {
      colors: {
        primary: { main },
        secondary: { red, green, yellow },
      },
    },
  }) => {
    switch (type) {
      case 'error':
        return `
          color: ${red};
          fill: ${red};
        `;
      case 'info':
        return `
          color: ${main};
          fill: ${main};
        `;
      case 'success':
        return `
          color: ${green};
          fill: ${green};
        `;
      case 'warning':
        return `
          color: ${yellow};
          fill: ${yellow};
        `;
    }
  }}
`;

export const IconContainer = styled.div`
  position: absolute;
  width: 2.4rem;
  height: 2.4rem;
  top: -0.3rem;
  left: 0;
`;
